import { ReactElement } from 'react';
import { useAppSelector } from 'app/store';
import PropTypes from 'prop-types';
import type { ReactNode } from 'react';
import { BottomFromTechnicianCoordinatorRoles } from '../../constants';

interface IsBottomFromTechnicianCoordinatorProps {
  children: ReactNode;
}

export function IsBottomFromTechnicianCoordinator({
  children
}: IsBottomFromTechnicianCoordinatorProps): ReactElement | null {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromTechnicianCoordinatorRoles.includes(role))) {
    return <>{children}</>;
  }
  return null;
}

IsBottomFromTechnicianCoordinator.propTypes = {
  children: PropTypes.node.isRequired
};
